module.exports = __webpack_public_path__ + "media/images/icon__point--default-4be8b408a32c36b998134e3173c53168.png";